<template>
    <div>
        <message-component 
            id="message" 
            v-model="isMessage" 
            :success="this.message.success" 
        >{{ message.text }}</message-component>
        <v-row justify="center">
            <v-col
                cols="12"
                sm="6"
                md="6"
                >
                <h5 class="text-center mt-16" v-if="groupe.name == null">
                    {{ company.name }}へ招待されました
                </h5>
                <h5 class="text-center mt-16" v-else>
                    {{ company.name }}（グループ: {{ groupe.name }}）へ招待されました
                </h5>
                <h5 class="text-center mt-2">
                    参加を承諾しますか 
                </h5>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="12"
                sm="6"
                md="6"
                >
                <p class="text-center red--text mt-8">
                    参加すると、グループ共有された書類を、過去に送受信した書類を含め、<br>下書き以外のすべての書類を確認可能となります。<br>
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="12"
                sm="3"
                md="3"
                >
                <div class="mt-4">
                    <v-checkbox
                        v-model="check"
                        @click="checked()"
                    >
                        <template v-slot:label>
                            <div>
                                DX-Signの
                                  <a
                                    target="_blank"
                                    href="/documents/terms"
                                    @click.stop
                                  >
                                    利用規約
                                  </a>
                              に同意する
                            </div>
                        </template>
                    </v-checkbox>
                </div>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="12"
                sm="3"
                md="3"
                >
                <div class="text-center mb-8">
                    <v-btn
                        v-model="decline"
                        color="blue-grey lighten-3"
                        class="white--text mr-8"
                        @click="decline()"
                    >
                        辞退
                    </v-btn>
                    <v-btn
                        v-model="consent"
                        color="red"
                        class="white--text"
                        :disabled="disabled"
                        @click="consented()"
                    >
                        承諾
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: ['invitation_key', 'company', 'groupe'],
        data() {
            return {
                items: [],
                check: false,
                disabled: true,
                consent: '',
                message: {
                    success: false,
                    text: '',
                },
          };
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message.text != '' && this.message.text != null;
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        methods: {
            // チェック押下
            checked() {
                this.disabled = this.disabled? false : true;
            },
            // 承諾
            consented() {
                axios.post('/documents/consent', {'key': this.invitation_key}).then(res => {
                        this.message.success = res.data.success;
                        this.message.text = res.data.message;
                        if (res.data.success) {
                            window.location = "/documents/consented";
                        }
                    }).catch(res => {
                      // console.log(res);
                        this.message.success = false;
                        this.message.text = "処理に失敗しました";
                    }).finally(() => {
                    });
            },
            // 却下
            decline() {
                axios.post('/documents/decline', {'key': this.invitation_key}).then(res => {
                        this.message.success = res.data.success;
                        this.message.text = res.data.message;
                        if (res.data.success) {
                            window.location = "/documents/decline-complete";
                        }
                    }).catch(res => {
                      // console.log(res);
                        this.message.success = false;
                        this.message.text = "処理に失敗しました";
                    }).finally(() => {
                    });
            }
        }
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
        font-size: $font-size-root;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        font-size: 16px !important;
        color: black !important;
    }
</style>